import React from "react";
export default function MobileBottomnav() {
  return <div></div>;
}
